module.exports = __webpack_public_path__ + "static/media/185-gibraltar.f7c41291.svg";